import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { AnnouncementMutationKeys } from '@/modules/announcement/keys'
import {
	UpdateAnnouncementRequest,
	UpdateAnnouncementResponse,
} from '@/modules/announcement/type'
import { updateAnnouncement } from '../../services'

interface UseMutationUpdateAnnouncementProps {
	id: string
	payload: UpdateAnnouncementRequest
}

export default function useMutationUpdateAnnouncement(
	props?: UseBaseMutationOptions<
		UpdateAnnouncementResponse,
		UseMutationUpdateAnnouncementProps
	>,
) {
	return useMutation({
		mutationKey: [AnnouncementMutationKeys.updateAnnouncement],
		mutationFn: (params) => updateAnnouncement(params.id, params.payload),
		...props,
	})
}
